import type {
  TGetAccount,
  TGetUser,
  THasStations,
  TSignUp,
  TUpdateAccount,
  TUpdateUser,
  TValidatePassword,
} from '@/types/profile';

import { profileService, accountService } from '@/api/private';
import { publicProfileService } from '@/api/public';

export const signUpUser: TSignUp = (data) => publicProfileService.post('', data);

export const getUserInfo: TGetUser = (signal) => profileService.get('', { signal });

export const updateUserInfo: TUpdateUser = (data) => profileService.patch('', data);

export const validatePassword: TValidatePassword = (data) =>
  profileService.post('/password-validation', data);

export const getAccountInfo: TGetAccount = (signal) => accountService.get('', { signal });

export const updateAccountInfo: TUpdateAccount = (data) => accountService.patch('', data);

// ToDo: Reconsider servers/services split
export const hasStations: THasStations = (signal) =>
  accountService.get('/partner/has-stations', {
    baseURL: '/core',
    signal,
  });

// Get accounts list
export const getAccountsList = (signal?: AbortSignal) => accountService.get('', { signal });
